// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Table_mainWrapper__GGR+D","header":"Table_header__X2D6S","downloadButton":"Table_downloadButton__5bIs+"};